export const parseRoleLabel = (role: string) => {
  const name = role.split('_')[1].toLowerCase();
  return `${name.charAt(0).toUpperCase()}${name.slice(1)}`;
};
